import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-grape/15 bg-white p-5 shadow-[0_12px_30px_-24px_rgba(16,42,67,0.45)]" style={{
    paddingTop: "5px",
    paddingBottom: "6px"
  }} data-id="element-175" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-176" data-mp="386kdqnblfm8v">
        <img src={testimonial.img} alt={testimonial.name} className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-grape/40" data-id="element-177" data-mp="38598ej2i26fn" />
        <div className="min-w-0" data-id="element-178" data-mp="19takqwh3czcp">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-179" data-mp="1drrlmy9x5dlo">
            <span className="text-sm font-bold text-plum" data-id="element-180" data-mp="hskpsokjpe3k">{testimonial.name}</span>
            <span className="flex gap-0.5 text-blush" aria-label="5 out of 5 stars" data-id="element-181" data-mp="hunri5v28vo4">
              {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-182" data-mp="842swifdzr57" data-mpi={k} />)}
            </span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-plum/55" data-id="element-183" data-mp="359f0ow6ty4i">
            <span data-id="element-184" data-mp="10s8cv2ym9c3z">📍 {testimonial.location}</span>
            <span className="text-sm leading-none" aria-hidden="true" data-id="element-185" data-mp="10qx9v5czw8dx">
              {testimonial.flag}
            </span>
          </div>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-grape/10 pt-4 text-[15px] leading-relaxed text-plum/75" style={{
      paddingTop: "0px"
    }} data-id="element-186" data-mp="qshgswueqp1s">
        “{testimonial.quote}”
      </blockquote>
    </motion.figure>;
}